export default {
  init() {

  },
  finalize() {
    // Enable or disable the filter items
    function setFilterStatus(disabled = true) {
      if ($('.filter-item').length > 0) {
        $('.filter-item').each(function() {
          $(this).find('.filter-btn-custom').each(function() {
            $(this).prop('disabled', disabled);
          });
        });
      }

      // also disable confirm button on mobile
      $('.mobile-filter-btn').prop('disabled', disabled);
    }

    // Called whenever a filter is changed
    let timeWhenFilterLastChanged = 0;

    function filterChanged(btnClicked = false) {
      if ($(window).width() < 996) {
        // change when button clicked only only mobile
        if (btnClicked) {
          $('.items-holder').empty();
          populateNewsLister(1, true);
        }
      } else {
        // gives a grace period before making the AJAX call
        const d = new Date();
        timeWhenFilterLastChanged = d.getTime();

        setTimeout(function() {
          const new_d = new Date();
          if (new_d.getTime() - timeWhenFilterLastChanged >= 1000) {
            $('.items-holder').empty();
            populateNewsLister(1);
          }
        }, 2000);
      }
    }

    // AJAX call to populate the page with relevant news items according to filters etc.
    function populateNewsLister(page, isMobile = false) {
      $('#load-more').hide();
      const $filterTopicChecked = $('[name="filter-topic"]:checked');
      const $filterAreaChecked = $('[name="filter-location"]:checked');

      let category = 0;
      let locations = 0;

      if ($filterTopicChecked.length > 0) {
        category = [];

        $filterTopicChecked.each(function() {
          category.push($(this).val());
        });
      }

      if ($filterAreaChecked.length > 0) {
        locations = [];

        $filterAreaChecked.each(function() {
          locations.push($(this).val());
        });
      }

      // Disable filters
      setFilterStatus(true);

      // make AJAX call
      $.ajax({
        url: '/wp-json/news-listing-api/v1/get',
        data: {
          page: page,
          category: category,
          locations: locations,
        },
      }).done(function(response) {
        const response_data = JSON.parse(response);

        if (response_data.pages > 0) {
          $('#load-more').show();
        }

        response_data.data.forEach((item) => {

          const $newsItem = $('.news-item-wrap-template').clone();
          $newsItem.removeClass('news-item-wrap-template');
          $newsItem.removeClass('d-none');
          $newsItem.addClass('news-item-wrap');

          const itemThumbnail = item['thumbnail'];
          const itemTitle = item['title'];
          const itemDescription = item['description'];
          const itemPermalink = item['permalink'];
          const itemTerms = item['terms'];

          $newsItem.find('.item-thumbnail-link').prop('href', itemPermalink);
          $newsItem.find('.item-thumbnail-link').prop('aria-label', itemTitle);

          $newsItem.find('.item-thumbnail').css({
            'background-image': `url('${itemThumbnail}')`,
          });

          $newsItem.find('.item-title').html(itemTitle);
          $newsItem.find('.item-title').prop('href', itemPermalink);
          $newsItem.find('.item-title').prop('aria-label', itemTitle);

          $newsItem.find('.item-description').html(itemDescription);

          $newsItem.find('.item-readmore').prop('href', itemPermalink);
          $newsItem.find('.item-readmore').prop('aria-label', itemTitle);

          // categories
          if (itemTerms.categories) {
            itemTerms.categories.forEach((term) => {
              const $termItem = $(`<a href="?category=${term['slug']}" class="tag-item">${term['name']}</a>`);
              $newsItem.find('.item-tags').append($termItem);
            });
          }

          // locations
          if (itemTerms.locations) {
            itemTerms.locations.forEach((term) => {
              const $termItem = $(`<a href="?location=${term['slug']}" class="tag-item">${term['name']}</a>`);
              $newsItem.find('.item-tags').append($termItem);
            });
          }

          $('.items-holder').append($newsItem);
        });

        // Enable filters
        setFilterStatus(false);

        // Close filter box on mobile
        if (isMobile) {
          $('body').removeClass('overflow-hidden');
          $('body').removeClass('dialog-padder');
          $('.filter-wrap').removeClass('wrap-open');

          $('.filter-item').each(function() {
            $(this).find('.filter-body').stop().hide();
          });
        }
      });
    }

    if ($('.filter-select').length > 0) {
      // Turn all filters into custom filters
      $('.filter-select').each(function() {
        const $filterBody = $(this).parent();
        const selectName = $(this).prop('name');
        const optionValue = $(this).prop('value');
        const optionText = $(this).data('text');

        const $filterOption = $('.filter-btn-custom-template').clone();
        $filterOption.removeClass('filter-btn-custom-template');
        $filterOption.addClass('filter-btn-custom');
        $filterOption.data('select-name', selectName);
        $filterOption.data('option-value', optionValue);
        $filterOption.find('.filter-btn-text').html(optionText);

        $filterBody.append($filterOption);

        if ($(this).is(':checked')) {
          $filterOption.addClass('is-checked');
        }

        // Filter functionality
        $filterOption.on('click', function() {
          const the_selectName = $(this).data('select-name');
          const the_optionValue = $(this).data('option-value');

          const $the_checkbox = $(`[name="${the_selectName}"][value="${the_optionValue}"]`);
          $the_checkbox.prop('checked', !$the_checkbox.prop('checked'));
          $(this).toggleClass('is-checked');

          filterChanged();
        });
      });
    }

    // Load more
    $('#load-more').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      populateNewsLister($(this).data('page') + 1);
      $(this).data('page', $(this).data('page') + 1);
    });

    // Open and close filter boxes
    if ($('.filter-item').length > 0) {
      $('.filter-item').each(function() {
        const $this_ = $(this);

        $this_.find('.item-head').on('click', function() {
          $this_.toggleClass('item-open');
          $this_.find('.item-body').stop().slideToggle(250);
        });
      });
    }

    // Open and close filter wrap in mobile
    $('.filter-mobile-toggle').on('click', function() {
      $('body').addClass('overflow-hidden');
      $('body').addClass('dialog-padder');
      $('.filter-wrap').addClass('wrap-open');

      $('.filter-item').each(function() {
        $(this).find('.filter-body').stop().show();
      });
    });

    // Click 'Confirm' on mobile
    $('.mobile-filter-btn').on('click', function() {
      filterChanged(true);
    });

    // Close filter wrap on mobile
    $('.mobile-filter-close').on('click', function() {
      $('body').removeClass('overflow-hidden');
      $('body').removeClass('dialog-padder');
      $('.filter-wrap').removeClass('wrap-open');

      $('.filter-item').each(function() {
        $(this).find('.filter-body').stop().hide();
      });
    });

    populateNewsLister(1);
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/template-news-listing.js